import { createI18n } from "vue-i18n";
import { supportedLocales } from "@/constants/locale";

// Return the language from the store if it exists
const store = JSON.parse(sessionStorage.getItem("session") || "{}");
const userLocale = store?.language || navigator.language;
// Check if the local language is supported. If not, use "en-GB" as a fallback.
const locale = Object.keys(supportedLocales).includes(userLocale)
    ? userLocale
    : "en-GB";

const i18n = createI18n({
    locale,
    fallbackLocale: "en-GB",
    allowComposition: true,
    messages: supportedLocales,
});

/**
 * Extra address-field labels not yet shipped in @esenda/core-ui.
 * These cover country-specific terminology for region/state equivalents
 * (e.g. Emirate for UAE, Province for Canada, Prefecture for Japan).
 *
 * We use mergeLocaleMessage so that the base messages retain their
 * original strongly-typed schema and TypeScript stays happy.
 */
i18n.global.mergeLocaleMessage("en-GB", {
    labels: {
        emirate: "Emirate",
        province: "Province",
        prefecture: "Prefecture",
        area: "Area",
    },
});
i18n.global.mergeLocaleMessage("fr-FR", {
    labels: {
        emirate: "Émirat",
        province: "Province",
        prefecture: "Préfecture",
        area: "Zone",
    },
});
i18n.global.mergeLocaleMessage("de-DE", {
    labels: {
        emirate: "Emirat",
        province: "Provinz",
        prefecture: "Präfektur",
        area: "Bereich",
    },
});

export const translationExists = (key: string): boolean => {
    /**
     * Checks if the key exist in the list of internationalised messages.
     * It checks in the "en-GB" locale for now as we do not have any other
     * translation languages enabled. Once we add more language support, we
     * can change the "en-GB" value to the user's locale
     * @param {string} key
     * @returns {boolean}
     */
    return i18n.global.te(key, locale);
};

export default i18n;
